import React from "react";
import { useLocation } from "react-router-dom";
import "../css/FloatingButtons.css";

// Import icons from assets
import whatsappIcon from "../assets/icons8-whatsapp-48.png";
import callIcon from "../assets/icons8-call-64.png";

const FloatingButtons = () => {
  const location = useLocation();
  
  // Check if current page is Washing Machine Service
  const isWashingMachinePage = location.pathname === "/washing-machine-service";

  // Dynamic clean phone number assignment
  const currentPhoneNumber = isWashingMachinePage ? "7317596984" : "7237898275";

  return (
    <>
      {/* Call Button */}
      <a
        href={`tel:${currentPhoneNumber}`}
        className="floating-btn call-btn"
        aria-label="Call Now"
      >
        <img src={callIcon} alt="Call Icon" className="icon-img" />
        Call Now
      </a>

      {/* WhatsApp Button */}
      <a
        href={`https://wa.me/91${currentPhoneNumber}`}
        target="_blank"
        rel="noopener noreferrer"
        className="floating-btn whatsapp-btn"
        aria-label="Chat on WhatsApp"
      >
        <img src={whatsappIcon} alt="WhatsApp Icon" className="icon-img" />
        Chat Now
      </a>
    </>
  );
};

export default FloatingButtons;